// extracted by mini-css-extract-plugin
var _1 = "K8Q1Mczq";
var _2 = "i2G5lnLT";
var _3 = "N0lL6YXA";
var _4 = "gV234e9X";
var _5 = "c9YGD3jc";
var _6 = "HvzjW2ol";
var _7 = "gV234e9X";
var _8 = "c9YGD3jc";
var _9 = "HvzjW2ol";
var _a = "iDLRrmk6 btn-secondary";
var _b = "iDLRrmk6 btn-secondary";
var _c = "Dq_egvhU";
export { _1 as "message", _2 as "name", _3 as "price", _4 as "similar-product", _5 as "similar-products", _6 as "similar-products-list", _7 as "similarProduct", _8 as "similarProducts", _9 as "similarProductsList", _a as "toggle-button", _b as "toggleButton", _c as "wrapper" }
